import { USER_ROLES } from '@didaskill/domain/users/constants';

import { hasUnrestrictedLessonReadAccess } from '../editableVersions';

/**
 * Returns list filters to apply when fetching lessons for the given user.
 * Unrestricted roles (including SUPER_ADMIN) receive no extra scoping.
 * @param userId Authenticated user id.
 * @param roles Authenticated user roles.
 * @returns Access-control filters for the lessons list query.
 */
export function getLessonsListAccessFilter(
  userId: string,
  roles: USER_ROLES[],
): {
  editorId?: string;
  responsibleId?: string;
} {
  if (hasUnrestrictedLessonReadAccess(roles)) {
    return {};
  }

  if (roles.includes(USER_ROLES.EXTERNAL_EDITOR)) {
    return { responsibleId: userId };
  }

  return { editorId: userId };
}
